import * as React from 'react';
import { DisplayNumber, DisplayNumberProps } from 'ui/display-number/display-number';
import styles from './display-number-unit-of-measure.scss';
import { Label } from 'ui';

export interface DisplayNumberUnitOfMeasureProps extends DisplayNumberProps {
  childValues?: any;
  hideIfNoValues?: boolean;
}

export const DisplayNumberUnitOfMeasure = (props: DisplayNumberUnitOfMeasureProps) => {
  const {className, valueItem, childValues} = props;
  const propClone = {...props, className: styles.number};
  
  const hasChildValues = !!childValues?.filter(cv=>cv.value)?.length;
  const hideIfNoValues = props.hideIfNoValues && !valueItem?.value && !hasChildValues;
  return !hideIfNoValues && <div id={props.componentId} className={`${className} ${styles.numberWithUnit}`}>
    <Label label={props.label} classNames="label" />
    <div className={styles.container}>
      <DisplayNumber {...propClone} label={{ ...props.label, visible: false }} />
      <span className={styles.unit}>{props.children}</span>
    </div>
  </div>;
  };
